// API Reference: https://www.wix.com/velo/reference/api-overview/introduction
// “Hello, World!” Example: https://learn-code.wix.com/en/article/1-hello-world

$w.onReady(function () {
	$w("#readMoreButton").onClick(() => {
    $w("#readMoreStatebox").changeState("expandedState");
});

$w("#readLessButton").onClick(() => {
    $w("#readMoreStatebox").changeState("collapsedState");
});
	// Write your JavaScript here

	// To select an element by ID use: $w("#elementID")

	// Click "Preview" to run your code
});